import { createContext } from 'react';

export const ResellerContext = createContext({});
